import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { RestService } from '../../services/rest/rest.service';
import { RestOptions } from '../../services/rest/rest-request';
import { ChartData, PerformanceParams, PeriodData } from './performance.domain';

/**
 * This service will handle performance calls
 */
@Injectable({
  providedIn: 'root'
})
export class PerformanceRestService {
  constructor(private restService: RestService) {
  }

  getChartData(params: PerformanceParams): Observable<ChartData> {
    return this.restService.getResource('performance.chartData').get<ChartData>({ params } as RestOptions);
  }

  getPeriodData(params: PerformanceParams): Observable<PeriodData> {
    return this.restService.getResource('performance.periodData').get<ChartData>({ params } as RestOptions);
  }
}
